// extracted by mini-css-extract-plugin
export default {"burgerMenu":"BurgerMenu_burgerMenu__kwjbL","icon":"BurgerMenu_icon__UXJou","isOpen":"BurgerMenu_isOpen__5VhP9","isClose":"BurgerMenu_isClose__DqbCs"};